export default __webpack_public_path__ + "static/media/SeñorEquilibristaB.a1424dcd.png";